var exports = {
  "k": "TimestampWithTooltip.module__container___NXBaTF",
  "N": "TimestampWithTooltip.module__hiddenSpacer___NXBaTF",
};

module.exports = exports;
